import React, { useState } from 'react';
import PropTypes from 'prop-types';
import isEmpty from 'lodash/isEmpty';
import get from 'lodash/get';
import { FormattedMessage } from 'react-intl';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faStar } from '@fortawesome/free-solid-svg-icons';
import { Button } from 'reactstrap';
import { Link } from 'react-router-dom';

import { currencyCode } from 'Helpers/Geo/data';
import FixedImg from 'Components/Utility/FixedImg';
import SpecialFormattedNumber from 'Containers/Utility/Price/SpecialFormattedNumber';

import 'Components/Cards/FreeProductCard.scss';

export default function SelectedFreeProductContainer({ promotion, product }) {
  const [moreProductsOpen, setProductsOpen] = useState(false);

  const requiredProducts = get(promotion, 'required_products', []);
  const minSpend = get(promotion, `min_spend[${currencyCode}]`, 0);

  return (
    <div className="free-game-promotion-banner">
      <div className="promotion-banner-content">
        <div className="title-text-container">
          <div className="icon-title-container">
            <div className="icon-container">
              <FontAwesomeIcon icon={faStar} />
            </div>
            <div className="title-container">
              <FormattedMessage
                id="selected.promotion-banner.promotion-title"
                defaultMessage="This game is part of a promotion."
              />
            </div>
          </div>
          {!isEmpty(requiredProducts) && minSpend > 0 &&
            <div className="description-text">
              <FormattedMessage
                id="selected.promotion-banner.description.required-min-spend"
                defaultMessage="Get {productName} for {freeText} when you spend over {minSpendAmount} and purchase one of the following products:"
                values={{
                  freeText: <span className="free-text">
                    <FormattedMessage
                      id="selected.promotion-banner.free-ribbon"
                      defaultMessage="FREE"
                    />
                  </span>,
                  productName: <b>{product.name}</b>,
                  minSpendAmount: <SpecialFormattedNumber
                    value={minSpend / 100}
                    style="currency"
                  />,
                }}
              />
            </div>
          }
          {isEmpty(requiredProducts) && minSpend > 0 &&
            <div className="description-text">
              <FormattedMessage
                id="selected.promotion-banner.description.not-required-min-spend"
                defaultMessage="Get {productName} for {freeText} when you spend over {minSpendAmount} *exclusions apply"
                values={{
                  freeText: <span className="free-text">
                    <FormattedMessage
                      id="selected.promotion-banner.free-ribbon"
                      defaultMessage="FREE"
                    />
                  </span>,
                  productName: <b>{product.name}</b>,
                  minSpendAmount: <SpecialFormattedNumber
                    value={minSpend / 100}
                    style="currency"
                  />,
                }}
              />
            </div>
          }

          {!isEmpty(requiredProducts) && minSpend === 0 &&
            <div className="description-text">
              <FormattedMessage
                id="selected.promotion-banner.description.required-no-min-spend"
                defaultMessage="Get {productName} for {freeText} when you purchase one of the following products:"
                values={{
                  freeText: <span className="free-text">
                    <FormattedMessage
                      id="selected.promotion-banner.free-ribbon"
                      defaultMessage="FREE"
                    />
                  </span>,
                  productName: <b>{product.name}</b>,
                }}
              />
            </div>
          }

          {isEmpty(requiredProducts) && minSpend === 0 &&
            <div className="description-text">
              <FormattedMessage
                id="selected.promotion-banner.description.not-required-no-min-spend"
                defaultMessage="Get {productName} for {freeText} when you purchase from us *exclusions apply"
                values={{
                  freeText: <span className="free-text">
                    <FormattedMessage
                      id="selected.promotion-banner.free-ribbon"
                      defaultMessage="FREE"
                    />
                  </span>,
                  productName: <b>{product.name}</b>,
                }}
              />
            </div>
          }
        </div>

        {requiredProducts && requiredProducts.slice(0, 2).map(p =>
          <Link to={`/${p.type}/${p.slug}`} key={p._id} className="free-product-container">
            <div className="cover-container">
              <FixedImg
                src={p.cover}
                alt={p.name}
                subfolder="original"
                className="w-100"
              />
            </div>
            <div className="text-container">
              <div className="free-product-name">
                {p.name}
              </div>
            </div>
          </Link>,
        )}

        {moreProductsOpen && requiredProducts && requiredProducts.slice(2).map(p =>
          <Link to={`/${p.type}/${p.slug}`} key={p._id} className="free-product-container">
            <div className="cover-container">
              <FixedImg
                src={p.cover}
                alt={p.name}
                subfolder="original"
                className="w-100"
              />
            </div>
            <div className="text-container">
              <div className="free-product-name">
                {p.name}
              </div>
            </div>
          </Link>,
        )}

        {requiredProducts && requiredProducts.length > 2 &&
          <div className="promotion-view-more-container">
            <Button type="submit" color="secondary" className="promotion-view-more" onClick={() => setProductsOpen(!moreProductsOpen)}>
              {moreProductsOpen && <FormattedMessage id="selected.promotion-banner.showmore" defaultMessage="Show less" />}
              {!moreProductsOpen && <FormattedMessage id="selected.promotion-banner.showless" defaultMessage="Show {count} more" values={{ count: (requiredProducts.length - 2) }} />}
            </Button>
          </div>
        }
      </div>
    </div>
  );
}

SelectedFreeProductContainer.propTypes = {
  promotion: PropTypes.shape({}),
  product: PropTypes.shape({}),
};

SelectedFreeProductContainer.defaultProps = {
  promotion: {},
  product: {},
};
